import * as actionTypes from "../actions/index";
import {LOCATION_CHANGE} from "connected-react-router";

const defaultState = {
    documents: [],
    fetching: false,
    failed: false,
    // The document whose bytes were last fetched, plus the fetch flag the modal watches to fire
    // the download. Mirrors the documentToDownload / fetchingDocument pattern the articles and
    // application-policy reducers already use.
    documentToDownload: null,
    fetchingDocument: false,
    failedToGetDocument: false
};

const fetchGplPolicyDocumentFile = (state) => ({
    ...state,
    fetchingDocument: true,
    failedToGetDocument: false,
    documentToDownload: null
});

const fetchGplPolicyDocumentFileSuccess = (state, action) => ({
    ...state,
    documentToDownload: action.payload.body || null,
    fetchingDocument: false,
    failedToGetDocument: false
});

const fetchGplPolicyDocumentFileFailed = (state) => ({
    ...state,
    documentToDownload: null,
    fetchingDocument: false,
    failedToGetDocument: true
});

const fetchGplPolicyDocuments = (state) => ({
    ...state,
    fetching: true,
    failed: false
});

const fetchGplPolicyDocumentsSuccess = (state, action) => ({
    ...state,
    documents: action.payload.body || [],
    fetching: false,
    failed: false
});

const fetchGplPolicyDocumentsFailed = (state) => ({
    ...state,
    documents: [],
    fetching: false,
    failed: true
});

// Clears what the modal renders as feedback, on close. Deliberately does NOT clear
// fetchingDocument: closing the modal mid-download must not strip the flag the download effect
// watches for its true -> false transition, or the file that is already on its way would never be
// saved. documents is kept too, so reopening does not flash an empty table.
const clearGplPolicyDocumentsState = (state) => ({
    ...state,
    failed: false,
    failedToGetDocument: false,
    documentToDownload: null
});

export default (state = defaultState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_GPL_POLICY_DOCUMENTS: return fetchGplPolicyDocuments(state, action);
        case actionTypes.FETCH_GPL_POLICY_DOCUMENTS_SUCCESS: return fetchGplPolicyDocumentsSuccess(state, action);
        case actionTypes.FETCH_GPL_POLICY_DOCUMENTS_FAILED: return fetchGplPolicyDocumentsFailed(state, action);
        case actionTypes.FETCH_GPL_POLICY_DOCUMENT_FILE: return fetchGplPolicyDocumentFile(state, action);
        case actionTypes.FETCH_GPL_POLICY_DOCUMENT_FILE_SUCCESS: return fetchGplPolicyDocumentFileSuccess(state, action);
        case actionTypes.FETCH_GPL_POLICY_DOCUMENT_FILE_FAILED: return fetchGplPolicyDocumentFileFailed(state, action);
        case actionTypes.CLEAR_GPL_POLICY_DOCUMENTS_STATE: return clearGplPolicyDocumentsState(state, action);
        case LOCATION_CHANGE: return defaultState;
        case actionTypes.LOGOUT: return defaultState;
        default: return state;
    }
};
